export default "__VITE_ASSET__CJnL0rWX__"